import Component from "@glimmer/component";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { arrayOf, shape, string } from "prop-types";

import Select from "glesys-controlpanel/components/select";
import { service } from "@ember/service";

@forbidExtraArgs
export default class CountrySelect extends Component {
  @service intl;

  @arg(
    arrayOf(
      shape({
        code: string.isRequired,
        name: string.isRequired,
      }),
    ).isRequired,
  )
  countries;

  @arg(string) value;

  get items() {
    return [{ value: "", label: this.intl.t("component.country-select.default") }].concat(
      this.countries
        .map((country) => ({
          value: country.code,
          label: country.name,
        }))
        .toSorted((a, b) => a.label.localeCompare(b.label)),
    );
  }

  <template><Select data-test-country-select @items={{this.items}} @value={{this.value}} ...attributes /></template>
}
